<div class="grid stl-grid">
    <div class="group-background" id='stl-background'></div>
    <div id='stl-list'>
        <app-button-double-line-arrow *ngFor="let iPerson of people; let i = index" [showArrow]="false" [firstLine]="iPerson.name" [secondLine]="iPerson.email" (click)='onPersonSelected(iPerson.email)' [withBorder]="i !== people.length - 1"></app-button-double-line-arrow>
    </div>
</div>